<template>
    <auth-layout>
        <div class="auth-reset-password">
            <sep name="XL"></sep>
            <typo v-if="loading" name="title-18-bold">
                Authentification en cours...
                <v-progress-circular class="loading" :size="18" :width="2" :indeterminate="true" />
            </typo>
            <typo v-if="error" class="error" name="title-18-bold" v-html="error" />
        </div>
    </auth-layout>
</template>

<script>
import Vue from "vue";
import AuthLayout from "./AuthLayout.vue";
import { Services } from "src/services/Services";

export default Vue.extend({
    components: {
        AuthLayout,
    },
    data() {
        return {
            loading: false,
            error: "",
        };
    },
    async mounted() {
        if (this.$route.query.error) {
            this.displayError(this.$route.query.error);
        } else if (this.$route.query.token) {
            this.loading = true;
            Services.api.user.clean();
            Services.api.auth.setAccessToken(this.$route.query.token);
            const user = await Services.api.user.getMe();
            if (user === null) {
                this.displayError("sso/invalid-token");
            } else {
                window.location.href = "/espace-client";
            }
            this.loading = false;
        } else {
            window.location.href = "/";
        }
    },
    methods: {
        displayError(errorCode) {
            this.error = this.dico.errors[errorCode] || "Token Invalide";
        },
    },
    computed: {
        dico() {
            return this.$publicDico.login;
        },
    },
});
</script>

<style lang="sass" scoped>
.loading
    margin: 0 8px
.error
    ::v-deep a
        &:hover
            text-decoration: underline !important
</style>
